/**
 * Static allowlist of user aliases permitted to use the v2 mobile
 * experience in prod.
 *
 * This is a stopgap until per-user feature flags are served from the
 * backend (Orbit preferences or AppConfig). To add/remove users you
 * must update this file and deploy.
 *
 * The set is checked against the alias cached in localStorage by the
 * Midway auth flow. On a cold first visit the alias won't be present
 * yet, so the user falls through to the legacy app and picks up v2 on
 * the next page load once the alias is stored.
 */

/** Aliases enrolled in the v2 mobile pilot, grouped by BU for readability. */
const MOBILE_V2_PILOT_ALIASES: readonly string[] = [
  // AMZL
  'shpragy',
  'sararpo',
  'nicpears',
  'drmanasi',
  // SSD
  'joshwiar',
  'belhunte',
  // Sort Center
  'ricirwin',
  // AMXL
  'taurma',
  // Customer Fulfillment
  'jsoshe',
  'jstiki',
  'nelkayly',
  'kylebyer',
  // Pilot additions (BU unspecified — grouped pending confirmation)
  'mllunaa',
  'mjahchan',
  'kadbader',
  'eggerstn',
  'jessaid',
  'wdsjh',
  'houslaur',
  'fisry',
  'lumonica',
];

const allowSet = new Set(MOBILE_V2_PILOT_ALIASES);

/**
 * Returns true when the given alias is enrolled in the v2 mobile pilot.
 * Case-sensitive — aliases are always lowercase from Midway.
 */
export function isMobileV2PilotUser(alias: string | null | undefined): boolean {
  return !!alias && allowSet.has(alias);
}
